/**
 * The Org Chart module's permission vocabulary.
 *
 * Google Workspace remains the system of record for PEOPLE and REPORTING LINES:
 * neither is editable here, and every correction to them belongs upstream in the Admin
 * console — which is the whole point of the gap list.
 *
 * The one exception is leadership level (see ../level), and it is not a retreat from
 * that rule. Level decides where a card sits VERTICALLY among its siblings; Workspace
 * has no field for it, so there is no upstream to defer to and nothing for a sync to
 * overwrite. It is presentation, owned by the OS, and `editLevels` gates it.
 *
 * The ladder stays two rungs — View (everyone, via the All Users group) and Manage —
 * because both write capabilities suit the same person: whoever curates the directory.
 */
import { defineModulePermissions } from '@noissue/authz';

export const ORGCHART = defineModulePermissions({
  id: 'orgchart',
  name: 'Org Chart',
  icon: 'network',
  permissions: {
    view: {
      label: 'View the org chart',
      description: 'See people, reporting lines and source-data gaps.',
    },
    manage: {
      label: 'Sync the directory',
      description: 'Pull the latest people from Google Workspace into the chart.',
    },
    editLevels: {
      label: 'Set leadership levels',
      description:
        'Override the level read off a job title, to tier the chart correctly. ' +
        'Affects layout only — never the person, their title or their reporting line.',
    },
  },
  visibility: 'view',
  levels: [
    { key: 'view', label: 'View', grants: ['view'] },
    { key: 'manage', label: 'Manage', grants: ['view', 'manage', 'editLevels'] },
  ],
});
